export default __webpack_public_path__ + "static/landing-collab-top-image-a-fd042dc6a713775887ea1a313104071d.png";